import PRODUCT_TYPE, { OPEN } from "../const/products";
/**
 * Checks if a setpay loan is processing or not
 * - IS PROCESSING CONDITION:
 *  >- _From the installment of the loan:_
 *  >- loanTerm must be "0", no interestRate, no startdate, no endate
 *
 * - NOT PROCESSING CONDITIONS:
 *  >- If there is a condition OPEN tied to the set pay loan it is NOT processing
 *  >- If the product type is not INSTALLMENT_LOAN it is NOT processing
 *
 * @param installment Installment object with data such as loanTerm, interestRate, startDate, endDate
 * @param productType ProductType string indicating what type of Card or Loan this account is
 * @param conditions ConditionValues[] indicating any conditions tied to the product
 * @returns boolean indicating if a setpay loan is processing
 */
var getSetpayLoanProcessingStatus = function (installment, productType, conditions) {
    if (!(conditions === null || conditions === void 0 ? void 0 : conditions.includes(OPEN)))
        return false;
    if (productType !== PRODUCT_TYPE.INSTALLMENT_LOAN)
        return false;
    var _a = installment || {}, loanTerm = _a.loanTerm, interestRate = _a.interestRate, startDate = _a.startDate, endDate = _a.endDate;
    return loanTerm === "0" && !interestRate && !startDate && !endDate;
};
export default getSetpayLoanProcessingStatus;
//# sourceMappingURL=getSetpayLoanProcessingStatus.js.map